import { cssRule } from 'typestyle';

cssRule('.tb-help-menu', {
    width: '230px',
});

cssRule('.tb-help-search', {
    display: 'inline-block',
    verticalAlign: 'top',
    width: '230px',
    position: 'relative',
    marginBottom: '3px',
});

cssRule('.tb-copyright', {
    marginTop: '12px',
});

